export default __webpack_public_path__ + "static/media/inrlogo.f4271e98.svg";